import MuiCssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider, Theme as MaterialTheme, ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { light } from './system';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends MaterialTheme {}
}

export type ThemeProps = Record<string, unknown>;

const Theme: React.FC<ThemeProps> = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={light.mui}>
      <StyledThemeProvider theme={light.styled}>
        <>
          <MuiCssBaseline />
          {children}
        </>
      </StyledThemeProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);

Theme.displayName = 'Theme';

export { Theme };
